import { toJS } from 'mobx'
import { isArray, isEqual, isObject, transform } from 'lodash'

const isMediaBundle = (v: any) =>
    isObject(v) && !isArray(v) && 'uploaded' in v && 'uploadQueue' in v && 'deleteQueue' in v

const toMediaId = (media: any) => isObject(media) ? (media as any).id : media

/**
 * Media reaches the form either as the plain array of ids the API returns, or as the
 * write widget's { uploaded, uploadQueue, deleteQueue } bundle. The two are equivalent
 * only while nothing is queued, so anything queued stays visible to the comparison.
 */
const toComparable = (value: any): any => {
    if (isArray(value)) return value.map(toComparable)

    if (isMediaBundle(value)) {
        const uploaded = (value as any).uploaded?.map(toMediaId) ?? []
        const pendingUploads = (value as any).uploadQueue?.length ?? 0
        const pendingDeletes = (value as any).deleteQueue?.length ?? 0

        return (pendingUploads || pendingDeletes)
            ? { uploaded, pendingUploads, pendingDeletes }
            : uploaded
    }

    if (isObject(value)) {
        return transform(value, (result, v, k) => {
            result[k] = toComparable(v)
        }, {} as any)
    }

    return value
}

const hasDocumentDataChanges = (previous: any, incoming: any): boolean =>
    !isEqual(toComparable(toJS(previous)), toComparable(toJS(incoming)))

export { hasDocumentDataChanges }
